import React, { MouseEventHandler } from 'react';
import componentProps, { ComponentProps } from '../../../../helpers/componentProps';
import { generateKeyForElement } from '../../../../helpers/elementKeyHelper';
import { SimpleSecondaryNav, SimpleSecondaryNavItem } from '../../types';
import {
  InlineSecondaryNav,
  NavItemLink,
  SecondaryNavItemText,
  SecondaryNavItemWrapper,
} from './styles';

type SimpleSecondaryNavMenuItemProps = {
  navItem: SimpleSecondaryNavItem;
  isActive: boolean;
  onClick: MouseEventHandler;
};

const SimpleSecondaryNavMenuItem: React.FC<SimpleSecondaryNavMenuItemProps> = ({
  navItem: { name, url },
  onClick,
}) => (
  <NavItemLink key={name} href={url} onClick={onClick}>
    <SecondaryNavItemText>{name}</SecondaryNavItemText>
  </NavItemLink>
);

type SimpleSecondaryNavMobileProps = {
  secondaryNav: SimpleSecondaryNav;
} & ComponentProps;

const SimpleSecondaryNavMobile: React.FC<SimpleSecondaryNavMobileProps> = ({
  secondaryNav: { navItems },
  ...props
}) => {
  return (
    <InlineSecondaryNav
      data-testid="simple-secondary-nav-mobile"
      {...componentProps(props)}>
      {navItems.map((navItem) => (
        <SecondaryNavItemWrapper key={generateKeyForElement(navItem)}>
          <SimpleSecondaryNavMenuItem
            navItem={navItem}
            isActive={false}
            onClick={(event) => {
              if (navItem.onClick) {
                navItem.onClick(event);
              }
            }}
          />
        </SecondaryNavItemWrapper>
      ))}
    </InlineSecondaryNav>
  );
};

export default SimpleSecondaryNavMobile;
